import React, { useState } from "react"
import styled from "styled-components"
import Title from "@/containers/MoneyFortune/View/decorate/Title"
import AnswerCard from "@/containers/MoneyFortune/View/decorate/AnswerCard"
import BackBtn from "./BackBtn"

export default function QuestionCard({
  number,
  question,
  answers,
  type,
  changeQuestion,
  preQuestion,
  marks,
  setMarks,
  questionNum,
  setQuestionNum
}) {
  const [animation, SetAnimation] = useState(false)
  const [clicked, setClicked] = useState(false)

  const PreQuestion = () => {
    setQuestionNum(prevCount => prevCount - 1)
    marks.pop()
  }

  return (
    <Wrapper className={animation === true && "active"}>
      <TitleWrapper className="TitleWrapper">
        <Title title1={`Q${number}`} title2={question} type="question" />
      </TitleWrapper>
      <AnswersBlock
        className={type === "Image" ? "AnswersBlock image" : "AnswersBlock"}
      >
        {answers?.map(({ content, count1, count2, img }) => {
          const changeQuestionHolder = () => {
            if (clicked === false) {
              setClicked(true)
              setMarks([
                ...marks,
                {
                  id: number,
                  mark1: count1,
                  mark2: count2,
                  content: content
                }
              ])
              SetAnimation(true)
              changeQuestion()
            }
            return
          }

          return (
            <AnswerWrapper
              className={type === "Image" && "image"}
              key={content}
              onClick={changeQuestionHolder}
            >
              <AnswerCard
                content={type === "Image" ? img : content}
                type={type}
              />
            </AnswerWrapper>
          )
        })}
      </AnswersBlock>
      {questionNum > 1 && (
        <BTNWrapper>
          <BackBtn content="回上一題" onClick={PreQuestion} />
        </BTNWrapper>
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  padding: 20px;
  width: 100%;
  display: flex;
  gap: 30px;
  flex-direction: column;
  justify-content: space-between;
  &.active {
    .TitleWrapper {
      animation: QATitleback 1s forwards;
      @keyframes QATitleback {
        0% {
          opacity: 1;
          transform: translate(0, 0);
        }
        100% {
          opacity: 0;
          transform: translate(0, -10vh);
        }
      }
    }
    .AnswersBlock {
      animation: Blockback 1s forwards;
      will-change: transform;
      @keyframes Blockback {
        0% {
          opacity: 1;
          transform: translate(0, 0);
        }
        100% {
          opacity: 0;
        }
      }
    }
  }
`
const TitleWrapper = styled.div`
  animation: QATitle 1s forwards;
  max-width: 1000px;
  width: 100%;
  margin: 0 auto;
  transition: 0.3s;
  will-change: transform;
  @keyframes QATitle {
    0% {
      opacity: 0;
      transform: translate(0, -10vh);
    }
  }
`

const AnswersBlock = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  max-width: 800px;
  width: 100%;
  margin: 0 auto;
  gap: 16px;
  animation: QABlock 1.5s forwards;
  transition: 0.3s;
  will-change: transform;

  @keyframes QABlock {
    0% {
      opacity: 0;
    }
  }
  &.image {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    max-width: 1000px;
    @media (max-width: 768px) {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 16px;
      > div {
        max-width: 150px;
      }
    }
  }
`

const AnswerWrapper = styled.div`
  width: 100%;
`

const BackBtnWrapper = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
`

const BTNWrapper = styled.div`
  position: absolute;
  bottom: 0px;
  left: 0px;
  will-change: transform;
`
